import React from 'react'
import PartListGroup from './PartListGroup'
import {
    setQuantitySort,
    setDeliverySort,
    setPriceSort,
    selectSort,
    selectQuantitySort,
    selectDeliverySort,
    selectPriceSort
} from './sortSlice'
import isProd from '../../utils/constants/isProd'
import {useSelector, useDispatch} from 'react-redux'
import getSortSymbol from '../../utils/sort/getSortSymbol'
import Image from '../productinfo/Image'
import isAuthorized from '../../utils/constants/isAuthorized'
import {analogType, sphinxType} from '../../utils/constants/partGroupes'
import InfoStar from '../notepad/InfoStar'
import CompareIcon from '../compare/CompareIcon'
import Brand from '../productinfo/Brand'
import Related from '../productinfo/Related'
import RelatedIcon from '../productinfo/RelatedIcon'
import ModalAnalogs from '../modal/ModalAnalogs'
import {isMobile} from 'react-device-detect'
import ReactTooltip from "react-tooltip";
import _ from "lodash";
import { originalType } from '../../utils/constants/partGroupes'

const ResultTableGrouped = ({parts, title, type}) => {
    const dispatch = useDispatch()
    const sort = useSelector(selectSort)

    const quantitySort = useSelector(selectQuantitySort)
    const quantitySortOrder = quantitySort[type]
    const quantitySortSymbol = getSortSymbol(quantitySortOrder)

    const deliverySort = useSelector(selectDeliverySort)
    const deliverySortOrder = deliverySort[type]
    const deliverySortSymbol = getSortSymbol(deliverySortOrder)

    const priceSort = useSelector(selectPriceSort)
    const priceSortOrder = priceSort[type]
    const priceSortSymbol = getSortSymbol(priceSortOrder)
    const isRed = title === 'Товары с похожим артикулом или названием'

    const isOriginalParts = type === originalType
    const originalPart = _.first(parts)

    let subkitTextShown = false
    let kitTextShown = false

    return (
        <div className="result-group">
            {!isProd && (
                <div>
                    <div>Sort:</div>
                    <pre>
                        <code>{JSON.stringify(sort[type], null, 2)}</code>
                    </pre>
                </div>
            )}

            <h2 className={`result-group__title ${isRed ? 'red' : ''}`}>{title}</h2>
            <div className="result-table result-table-grouped" data-type={type}>
                <div className="result-table__header">
                    <div className="result-table__header-cell brand-article">
                        <span>Бренд/Артикул</span>
                    </div>
                    {isAuthorized && (
                        <div className="result-table__header-cell supplier">
                            <span>Поставщик</span>
                        </div>
                    )}
                    <div className="result-table__header-cell in-stock">
                        <span onClick={() => dispatch(setQuantitySort({type}))}>
                            Наличие, шт. {quantitySortSymbol}
                        </span>
                    </div>
                    <div className="result-table__header-cell delivery">
                        <span onClick={() => dispatch(setDeliverySort({type}))}>
                            Срок {deliverySortSymbol}
                        </span>
                    </div>
                    {/*<div className="result-table__header-cell tag"></div>*/}
                    <div className="result-table__header-cell price">
                        <span onClick={() => dispatch(setPriceSort({type}))}>
                            Цена {priceSortSymbol}
                        </span>
                    </div>
                    <div className="result-table__header-cell action">
                        <span>К-во, шт.</span>
                    </div>
                </div>
                <div className="result-table__body">
                    {parts.map((articleBrandParts, index) => (
                        <React.Fragment key={articleBrandParts.article + articleBrandParts.brand_title}>
                            {isOriginalParts ?
                                <>
                                    {articleBrandParts.is_subkit === "Y" && !subkitTextShown ?
                                        subkitTextShown = true && (
                                            <div className="result-table__kit-info">
                                                <span>{originalPart.original_article} {originalPart.brand_title} состоит из:</span>
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {articleBrandParts.is_kit === "Y" && !kitTextShown ?
                                        kitTextShown = true && (
                                            <div className="result-table__kit-info">
                                                <span>{originalPart.original_article} {originalPart.brand_title} входит в состав комплект{parts.filter((part) => part.is_kit === "Y").length > 1 ? "ов" : "а"}:</span>
                                            </div>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </>
                                :
                                (
                                    <></>
                                )
                            }

                            <div className="result-table__group" key={articleBrandParts.article + articleBrandParts.brand_title}>
                                <div className="result-table__info brand-article">
                                    {isAuthorized ? (
                                        <Image articleBrandParts={articleBrandParts}/>
                                    ) : (
                                        <></>
                                    )}
                                    <div className="result-table__info-text">
                                        <div className="result-table__info-ba">
                                            <Brand articleBrandParts={articleBrandParts}/>
                                            {isAuthorized &&
                                            (type === analogType || type === sphinxType ||
                                                articleBrandParts.is_subkit === "Y" || articleBrandParts.is_kit === "Y") ? (
                                                <a
                                                    data-tip data-for="tooltip_part_search"
                                                    className="result-table__info-article"
                                                    href={`/auto/search/${encodeURIComponent(encodeURIComponent(
                                                        articleBrandParts.article
                                                    ))}/?brand_title=${encodeURIComponent(
                                                        articleBrandParts.brand_title
                                                    )}`}
                                                >
                                                    {articleBrandParts.original_article}
                                                </a>
                                            ) : (
                                                <span className="result-table__info-article">
                                                {articleBrandParts.original_article}
                                            </span>
                                            )}
                                            {isAuthorized &&
                                            !isMobile &&
                                            type === analogType &&
                                            index === 0 ? (
                                                <ModalAnalogs/>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                        <InfoStar
                                            part_id={articleBrandParts.part_id}
                                            hash={articleBrandParts.notepad_hash}
                                        />
                                        {articleBrandParts.is_ib_element ?
                                            (
                                                <CompareIcon
                                                    part_id={articleBrandParts.part_id}
                                                    hash={articleBrandParts.notepad_hash}
                                                    article={articleBrandParts.original_article}
                                                    brand={articleBrandParts.brand_title}
                                                />
                                            ) : (
                                                <></>
                                            )
                                        }
                                        {articleBrandParts.is_rel_products ?
                                            (
                                                <RelatedIcon articleBrandParts={articleBrandParts}/>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        <div className="result-table__info-description">
                                            {articleBrandParts.title}
                                        </div>
                                        {articleBrandParts.is_rel_products ?
                                            (
                                                <Related articleBrandParts={articleBrandParts}/>
                                            ) : (
                                                <></>
                                            )
                                        }

                                    </div>
                                </div>
                                <PartListGroup parts={articleBrandParts.parts}/>
                                <ReactTooltip
                                    id="tooltip_part_search"
                                    place="top"
                                    type="dark"
                                    effect="solid"
                                    multiline={true}
                                >
                                    <span>Нажмите, чтобы увидеть аналоги.</span>
                                </ReactTooltip>
                                <ReactTooltip
                                    id="tooltip_compare"
                                    place="top"
                                    type="dark"
                                    effect="solid"
                                    multiline={true}
                                    afterShow={() => {
                                        setTimeout(ReactTooltip.hide, 3000)
                                    }}
                                >
                                <span>
                                    Не больше 4-х товаров
                                    <br/> к сравнению.
                                </span>
                                </ReactTooltip>
                                <ReactTooltip
                                    id="tooltip_delivery"
                                    place="top"
                                    type="dark"
                                    effect="solid"
                                    multiline={true}
                                    afterShow={() => {
                                        setTimeout(ReactTooltip.hide, 3000)
                                    }}
                                >
                                <span>
                                    Точный срок поставки <br/>уточняйте у менеджера
                                </span>
                                </ReactTooltip>
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ResultTableGrouped
